// extracted by mini-css-extract-plugin
module.exports = {"tagsWrapper":"styles_tagsWrapper__300HY","high":"styles_high__JTybD","mid":"styles_mid__2JLwi","low":"styles_low__2WGkV"};